// extracted by mini-css-extract-plugin
module.exports = {"bonus":"_12-Pw7","name":"rYYFGA"};